module.exports = __webpack_public_path__ + "img/6.f7368bc9.png";